var _g, _rect, _path, _path2, _rect2, _rect3, _rect4, _g2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _g3, _g4, _g5, _g6, _g7, _path3, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _g8, _rect20, _rect21, _rect22, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoWidgetsLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 632,
    height: 410,
    viewBox: "0 0 632 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15283_15386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.4351,
    y: 61.4652,
    width: 518.961,
    height: 318.344,
    rx: 12.013,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68.4053,
    y: 80.6141,
    width: 96.4797,
    height: 280.162,
    rx: 6.00649,
    fill: "#F4F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.042 108.273C100.119 108.353 100.179 108.448 100.219 108.551C100.262 108.656 100.285 108.768 100.286 108.881H92.2086L89.9697 108.856C89.9697 108.856 88.7328 108.888 87.7892 108.888H83.5747H79.8639C79.8619 108.775 79.8836 108.663 79.9275 108.558C79.9702 108.454 80.0339 108.359 80.1148 108.28L83.3468 105.054L85.4248 102.982L89.4537 98.9596C89.5334 98.8789 89.6283 98.8147 89.7329 98.7709C89.8384 98.728 89.9512 98.7058 90.0652 98.7056C90.1785 98.706 90.2907 98.7282 90.3956 98.7709C90.5008 98.8147 90.5963 98.8788 90.6766 98.9596L94.7408 103.005L96.8489 105.098L100.042 108.273Z",
    fill: "#DFE8FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5589 109.834L90.6789 115.661C90.5105 115.83 90.2971 115.912 90.0681 115.912C89.8391 115.912 89.6195 115.822 89.4573 115.661L83.5703 109.834H79.8633C79.8622 109.946 79.8838 110.058 79.9269 110.162C79.9695 110.266 80.0332 110.36 80.114 110.438L89.4591 119.688C89.5381 119.769 89.633 119.834 89.738 119.877C89.8431 119.921 89.9559 119.944 90.0699 119.944C90.1839 119.944 90.2967 119.921 90.4017 119.877C90.5067 119.834 90.6016 119.769 90.6806 119.688L100.035 110.438C100.115 110.359 100.18 110.265 100.223 110.162C100.266 110.058 100.287 109.946 100.285 109.834H96.5589Z",
    fill: "#DFE8FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5381,
    y: 131.377,
    width: 74.2151,
    height: 9.27689,
    rx: 1.45607,
    fill: "#DFE8FE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5381,
    y: 168.485,
    width: 74.2151,
    height: 9.27689,
    rx: 1.45607,
    fill: "#DFE8FE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5381,
    y: 149.931,
    width: 74.2151,
    height: 9.27689,
    rx: 1.45607,
    fill: "#DFE8FE"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_15283_15386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.835,
    y: 248.034,
    width: 381.547,
    height: 106.432,
    rx: 6.00649,
    fill: "white"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 193.914,
    y: 276.145,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#DFE8FE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 193.918,
    y: 316.31,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#DFE8FE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 193.917,
    y: 296.228,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#DFE8FE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 316.413,
    y: 276.146,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#DFE8FE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 316.41,
    y: 316.31,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#DFE8FE"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 316.413,
    y: 296.228,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#DFE8FE"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 438.908,
    y: 276.147,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#DFE8FE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 438.912,
    y: 316.311,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#DFE8FE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 438.908,
    y: 296.228,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#DFE8FE"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_15283_15386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.565,
    y: 80.686,
    width: 117.191,
    height: 50.4545,
    rx: 6.00649,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_15283_15386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305.976,
    y: 80.686,
    width: 117.191,
    height: 50.4545,
    rx: 6.00649,
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_15283_15386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.565,
    y: 140.751,
    width: 189.805,
    height: 96.1039,
    rx: 6.00649,
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_15283_15386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.387,
    y: 80.686,
    width: 117.191,
    height: 50.4545,
    rx: 6.00649,
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_15283_15386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 265.809,
    width: 79.2857,
    height: 79.2857,
    rx: 4.50577,
    fill: "#5F8AF6"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8317 288.807C51.8317 287.964 51.1481 287.28 50.3049 287.28C49.4617 287.28 48.7782 287.964 48.7782 288.807L48.7782 303.566H34.0194C33.1762 303.566 32.4927 304.249 32.4927 305.092C32.4927 305.936 33.1762 306.619 34.0194 306.619H48.7782V321.378C48.7782 322.221 49.4617 322.905 50.3049 322.905C51.1481 322.905 51.8317 322.221 51.8317 321.378V306.619H66.5904C67.4336 306.619 68.1172 305.936 68.1172 305.092C68.1172 304.249 67.4336 303.566 66.5904 303.566H51.8317L51.8317 288.807Z",
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 184.376,
    y: 101.108,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#DFE8FE"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 316.52,
    y: 101.108,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#DFE8FE"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 448.662,
    y: 101.108,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#DFE8FE"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 190.383,
    y: 224.842,
    width: 26.4286,
    height: 26.4286,
    rx: 1.45607,
    transform: "rotate(-90 190.383 224.842)",
    fill: "#DFE8FE"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 256.455,
    y: 224.842,
    width: 15.6169,
    height: 26.4286,
    rx: 1.45607,
    transform: "rotate(-90 256.455 224.842)",
    fill: "#DFE8FE"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 222.818,
    y: 224.842,
    width: 66.0714,
    height: 27.6299,
    rx: 1.45607,
    transform: "rotate(-90 222.818 224.842)",
    fill: "#DFE8FE"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 322.526,
    y: 224.842,
    width: 32.4351,
    height: 26.4286,
    rx: 1.45607,
    transform: "rotate(-90 322.526 224.842)",
    fill: "#DFE8FE"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 288.89,
    y: 224.842,
    width: 49.2532,
    height: 27.6299,
    rx: 1.45607,
    transform: "rotate(-90 288.89 224.842)",
    fill: "#DFE8FE"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_15283_15386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.123 63.7875C372.381 60.5544 374.4 57.3315 377.633 56.5891L575.503 11.1537C578.736 10.4113 581.959 12.4304 582.701 15.6636L619.533 176.067C620.276 179.3 618.257 182.523 615.024 183.265L417.154 228.701C413.92 229.443 410.698 227.424 409.955 224.191L373.123 63.7875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.294 63.5187C374.147 62.8815 374.135 62.2478 374.237 61.6448L373.053 61.4446C373.317 59.8774 374.199 58.4699 375.494 57.5479L376.191 58.5265C376.689 58.1717 377.264 57.9063 377.902 57.76L380.812 57.0918L380.543 55.921L386.362 54.5846L386.631 55.7555L392.451 54.4191L392.182 53.2483L398.002 51.912L398.271 53.0828L404.09 51.7465L403.821 50.5756L409.641 49.2393L409.91 50.4101L415.73 49.0738L415.461 47.903L421.281 46.5666L421.549 47.7374L427.369 46.4011L427.1 45.2303L432.92 43.8939L433.189 45.0648L439.009 43.7284L438.74 42.5576L444.559 41.2213L444.828 42.3921L450.648 41.0558L450.379 39.8849L456.199 38.5486L456.468 39.7194L462.287 38.3831L462.019 37.2123L467.838 35.8759L468.107 37.0467L473.927 35.7104L473.658 34.5396L479.478 33.2032L479.746 34.3741L485.566 33.0377L485.297 31.8669L491.117 30.5306L491.386 31.7014L497.206 30.3651L496.937 29.1942L502.756 27.8579L503.025 29.0287L508.845 27.6924L508.576 26.5216L514.396 25.1852L514.665 26.356L520.484 25.0197L520.216 23.8489L526.035 22.5125L526.304 23.6834L532.124 22.347L531.855 21.1762L537.675 19.8399L537.944 21.0107L543.763 19.6744L543.494 18.5035L549.314 17.1672L549.583 18.338L555.403 17.0017L555.134 15.8309L560.954 14.4945L561.222 15.6653L567.042 14.329L566.773 13.1582L572.593 11.8218L572.862 12.9927L575.772 12.3245C576.409 12.1782 577.043 12.166 577.646 12.2678L577.846 11.0833C579.413 11.3482 580.82 12.23 581.742 13.5247L580.764 14.2215C581.119 14.7197 581.384 15.2952 581.53 15.9324L582.188 18.7968L583.359 18.5279L584.674 24.2566L583.504 24.5255L584.819 30.2542L585.99 29.9853L587.305 35.714L586.134 35.9829L587.45 41.7115L588.621 41.4427L589.936 47.1714L588.765 47.4402L590.081 53.1689L591.252 52.9001L592.567 58.6288L591.396 58.8976L592.712 64.6263L593.882 64.3575L595.198 70.0862L594.027 70.355L595.342 76.0837L596.513 75.8149L597.829 81.5436L596.658 81.8124L597.973 87.5411L599.144 87.2723L600.46 93.0009L599.289 93.2698L600.604 98.9985L601.775 98.7297L603.09 104.458L601.92 104.727L603.235 110.456L604.406 110.187L605.721 115.916L604.551 116.185L605.866 121.913L607.037 121.644L608.352 127.373L607.181 127.642L608.497 133.371L609.668 133.102L610.983 138.831L609.812 139.099L611.128 144.828L612.299 144.559L613.614 150.288L612.443 150.557L613.759 156.285L614.929 156.017L616.245 161.745L615.074 162.014L616.389 167.743L617.56 167.474L618.876 173.203L617.705 173.472L618.363 176.336C618.509 176.973 618.521 177.607 618.419 178.21L619.604 178.41C619.339 179.977 618.457 181.385 617.162 182.307L616.466 181.328C615.967 181.683 615.392 181.948 614.755 182.095L611.845 182.763L612.114 183.934L606.294 185.27L606.025 184.099L600.205 185.435L600.474 186.606L594.655 187.943L594.386 186.772L588.566 188.108L588.835 189.279L583.015 190.615L582.746 189.444L576.927 190.781L577.195 191.952L571.376 193.288L571.107 192.117L565.287 193.453L565.556 194.624L559.736 195.961L559.468 194.79L553.648 196.126L553.917 197.297L548.097 198.633L547.828 197.462L542.008 198.799L542.277 199.97L536.458 201.306L536.189 200.135L530.369 201.471L530.638 202.642L524.818 203.979L524.549 202.808L518.73 204.144L518.998 205.315L513.179 206.651L512.91 205.48L507.09 206.817L507.359 207.988L501.539 209.324L501.27 208.153L495.451 209.49L495.72 210.66L489.9 211.997L489.631 210.826L483.811 212.162L484.08 213.333L478.261 214.669L477.992 213.499L472.172 214.835L472.441 216.006L466.621 217.342L466.352 216.171L460.533 217.508L460.801 218.678L454.982 220.015L454.713 218.844L448.893 220.18L449.162 221.351L443.342 222.687L443.073 221.517L437.254 222.853L437.523 224.024L431.703 225.36L431.434 224.189L425.614 225.526L425.883 226.696L420.063 228.033L419.795 226.862L416.885 227.53C416.248 227.676 415.614 227.689 415.011 227.587L414.811 228.771C413.243 228.506 411.836 227.625 410.914 226.33L411.893 225.633C411.538 225.135 411.272 224.559 411.126 223.922L410.468 221.058L409.297 221.327L407.982 215.598L409.153 215.329L407.837 209.6L406.667 209.869L405.351 204.141L406.522 203.872L405.207 198.143L404.036 198.412L402.72 192.683L403.891 192.414L402.576 186.686L401.405 186.954L400.089 181.226L401.26 180.957L399.945 175.228L398.774 175.497L397.459 169.768L398.629 169.5L397.314 163.771L396.143 164.04L394.828 158.311L395.998 158.042L394.683 152.313L393.512 152.582L392.197 146.854L393.368 146.585L392.052 140.856L390.881 141.125L389.566 135.396L390.737 135.127L389.421 129.399L388.25 129.668L386.935 123.939L388.106 123.67L386.79 117.941L385.62 118.21L384.304 112.481L385.475 112.213L384.16 106.484L382.989 106.753L381.673 101.024L382.844 100.755L381.529 95.0265L380.358 95.2954L379.042 89.5667L380.213 89.2978L378.898 83.5691L377.727 83.838L376.412 78.1093L377.582 77.8404L376.267 72.1117L375.096 72.3806L373.781 66.6519L374.951 66.3831L374.294 63.5187Z",
    stroke: "url(#paint0_linear_15283_15386)",
    strokeWidth: 2.4026,
    strokeDasharray: "6.01 6.01"
  }))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 528.062,
    y: 83.6752,
    width: 45.6493,
    height: 9.61039,
    rx: 1.45607,
    transform: "rotate(-12.9322 528.062 83.6752)",
    fill: "#DFE8FE"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 536.935,
    y: 122.312,
    width: 45.6493,
    height: 10.8117,
    rx: 1.45607,
    transform: "rotate(-12.9322 536.935 122.312)",
    fill: "#DFE8FE"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 532.633,
    y: 103.579,
    width: 45.6493,
    height: 9.61039,
    rx: 1.45607,
    transform: "rotate(-12.9322 532.633 103.579)",
    fill: "#DFE8FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M472.425 171.378C464.711 172.738 456.783 172.306 449.241 170.114C441.699 167.923 434.74 164.03 428.891 158.729C423.042 153.428 418.455 146.859 415.479 139.518C412.502 132.177 411.214 124.257 411.71 116.356C412.207 108.455 414.475 100.781 418.345 93.9141C422.214 87.0471 427.583 81.167 434.044 76.7186C440.506 72.2703 447.892 69.3701 455.643 68.2376C463.394 67.105 471.307 67.7697 478.784 70.1813L474.911 82.6178C469.303 80.8091 463.368 80.3106 457.555 81.16C451.742 82.0094 446.203 84.1845 441.356 87.5208C436.51 90.8571 432.484 95.2671 429.582 100.417C426.68 105.568 424.978 111.323 424.606 117.249C424.233 123.174 425.2 129.115 427.432 134.62C429.665 140.126 433.104 145.053 437.491 149.029C441.878 153.004 447.097 155.924 452.754 157.568C458.41 159.211 464.356 159.535 470.142 158.515L472.425 171.378Z",
    fill: "#DFE8FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M509.428 143.707C505.819 150.909 500.6 157.157 494.182 161.958C487.763 166.759 480.321 169.983 472.442 171.375L470.155 158.513C476.064 157.469 481.645 155.051 486.459 151.45C491.273 147.849 495.188 143.163 497.894 137.762L509.428 143.707Z",
    fill: "#3E6CE1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M486.695 73.4808C492.747 76.6171 498.134 80.924 502.549 86.1556C506.964 91.3873 510.321 97.4412 512.427 103.972C514.533 110.502 515.348 117.382 514.824 124.217C514.301 131.052 512.45 137.71 509.377 143.809L497.856 137.839C500.161 133.264 501.549 128.271 501.941 123.145C502.334 118.018 501.723 112.859 500.143 107.961C498.564 103.063 496.046 98.5222 492.735 94.5985C489.424 90.6748 485.383 87.4446 480.844 85.0924L486.695 73.4808Z",
    fill: "#5F8AF6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M433.297 77.2427C441.008 71.7299 450.08 68.4708 459.523 67.8212C468.966 67.1716 478.417 69.1563 486.845 73.5589L480.957 85.151C474.636 81.8491 467.547 80.3605 460.465 80.8477C453.383 81.3349 446.579 83.7792 440.796 87.9138L433.297 77.2427Z",
    fill: "#A9C2FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15283_15386",
    x: 35.4156,
    y: 43.4457,
    width: 567.013,
    height: 366.396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.00649,
    dy: 6.00649
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.013
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.754618 0 0 0 0 0.757499 0 0 0 0 0.858333 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15283_15386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15283_15386",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_15283_15386",
    x: 159.419,
    y: 237.223,
    width: 407.976,
    height: 132.86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.2013,
    dy: 2.4026
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.60714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.562222 0 0 0 0 0.580156 0 0 0 0 0.766667 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15283_15386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15283_15386",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_15283_15386",
    x: 159.149,
    y: 69.8743,
    width: 143.62,
    height: 76.8831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.2013,
    dy: 2.4026
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.60714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.562222 0 0 0 0 0.580156 0 0 0 0 0.766667 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15283_15386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15283_15386",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_15283_15386",
    x: 291.56,
    y: 69.8743,
    width: 143.62,
    height: 76.8831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.2013,
    dy: 2.4026
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.60714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.562222 0 0 0 0 0.580156 0 0 0 0 0.766667 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15283_15386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15283_15386",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_15283_15386",
    x: 159.149,
    y: 129.939,
    width: 216.234,
    height: 122.532,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.2013,
    dy: 2.4026
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.60714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.562222 0 0 0 0 0.580156 0 0 0 0 0.766667 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15283_15386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15283_15386",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_15283_15386",
    x: 423.971,
    y: 69.8743,
    width: 143.62,
    height: 76.8831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.2013,
    dy: 2.4026
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.60714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.562222 0 0 0 0 0.580156 0 0 0 0 0.766667 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15283_15386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15283_15386",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_15283_15386",
    x: 0.186157,
    y: 257.699,
    width: 99.111,
    height: 99.1111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.901154,
    dy: 1.80231
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.95634
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.562222 0 0 0 0 0.580156 0 0 0 0 0.766667 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15283_15386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15283_15386",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_15283_15386",
    x: 358.554,
    y: 0.188312,
    width: 273.146,
    height: 244.283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.2013,
    dy: 2.4026
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.60714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.562222 0 0 0 0 0.580156 0 0 0 0 0.766667 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15283_15386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15283_15386",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15283_15386",
    x1: 372.969,
    y1: -8.60691,
    x2: 664.187,
    y2: 60.0373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#597BF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4365E5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWidgetsLight);
export default __webpack_public_path__ + "static/media/noWidgetsLight.e28bd7102abbd2b1241667a3a9ab6f0e.svg";
export { ForwardRef as ReactComponent };